import {
  TEST,
  marketing,
  SELLERSIGNFN,
  MODELTITLE,
  POINTUSERINFO,
  LOGINUSERINFO,
  CITYPROVINCEDATA,
  SHOPINFO
} from "./mutation-types.js";
//自定义改变state初始值的方法，这里面的参数除了state之外还可以再传额外的参数(变量或对象);

import Vue from "vue";

const pageArr = [
  ,
  "menberPage",
  "integralTask",
  "integralPlay",
  "integralShop",
  "personalCenter",
]; // 页面
const configArr = [
  ,
  "powerList",
  "hotList",
  "exchangeList",
  "activityList",
  "playList",
  ,
  ,
  "actualList",
  "couponList",
  "detailedList",
]; // 每个页面的组件列表
const pageLink = [
  ,
  //  0
  // 存储H5里边玩法页面的路径
  "https://yq-hd-rc.isvjcloud.com/jd-hd-h5/sign_polite", //每日签到    1 //2  浏览有礼
  ,
  "https://yq-hd-rc.isvjcloud.com/jd-hd-h5/rob_goodPresent", //每日抢好礼 3
  "https://yq-hd-rc.isvjcloud.com/jd-hd-h5/attention_shop", //关注店铺有礼 4
  "https://yq-hd-rc.isvjcloud.com/jd-hd-h5/invitationopenCard", //邀请开卡 5
  "https://yq-hd-rc.isvjcloud.com/jd-hd-h5/invitationattention", //邀请关注店铺 6
  "https://yq-hd-rc.isvjcloud.com/jd-hd-h5/perfect_information", //完善信息有礼 7
  "https://yq-hd-rc.isvjcloud.com/jd-hd-h5/lottery_turntable", //幸运抽奖 8
  "https://yq-hd-rc.isvjcloud.com/jd-hd-h5/integralStore_exchange", //积分兑换实物  9
  "https://yq-hd-rc.isvjcloud.com/jd-hd-h5/integralStore_discount", //积分兑换优惠券 10
  ,
];
// 会员权益的tab栏选中
let selectPowerItem = 0;

export default {
  /**
   *存储短信模板title
   * @param state
   * @param val
   */
  [MODELTITLE](state, val) {
    state.modelName = val;
  },
  /**
   *存储登录客户信息
   * @param state
   * @param val
   */
  [LOGINUSERINFO](state, val) {
    state.loginUserInfo = val;
  },
  /**
   *存储省市地区信息
   * @param state
   * @param val
   */
   [CITYPROVINCEDATA](state, val) {
    state.cityProvinceData = val;
  },
  /**
   *存储积分登录客户信息
   * @param state
   * @param val
   */
  [POINTUSERINFO](state, val) {
    state.pointUserInfo = val;
  },
  /**
   * 存储店铺信息 
   * @param {*} state 
   * @param {*} arr 
   */
  [SHOPINFO](state, val) {
    state.shopInfo = val;
  },
  // 店铺列表
  getSwitchList(state, arr) {
    state.switchList = arr;
  },
  //自定义改变state初始值的方法，这里面的参数除了state之外还可以再传额外的参数(变量或对象);
  switchPages(state, id) {
    state.selectPage = id;
  },
  switchColor(state, { color, choice }) {
    choice
      ? (state.pageConfig.menberPage.bgColor = color)
      : (state.pageConfig.menberPage.color = color);
  },
  setRefresh(state,val){
    console.log('setRefresh');
    state.isRefresh = val
  },
  // 左侧业务组件禁用
  componentListChange(state, index) {
    state.componentList[state.selectPage - 1][index].disabled = true;
  },
  // // 左侧业务组件全部开启
  componentListChangeTurnOn(state) {
    // state.componentList[state.selectPage - 1][index].disabled = true;
    state.componentList.map(item=>{
      // item.disabled = falseitem
      if(Array.isArray(item)){
        item.map(item2=>{
          item2.disabled = false
        })
      }
    })
  },
  // 切换右侧要显示的配置项
  switchConfigState(state, value) {
    const index = state.selectPage;
    state.pageConfig[pageArr[index]].configState = value;
    if (!value) return;
    const curConfig = state.pageConfig[pageArr[index]].pageComponents.find(
      (item) => item.select
    );
    state.pageConfig[pageArr[index]].pageHideGaps = curConfig.hideGaps;
  },
  // 会员权益添加
  addPowerItem(state) {
    if (state.pageConfig.menberPage.powerList.length >= 8) return;
    const ids = state.pageConfig.menberPage.powerList.map((item) => item.id);
    const max = Math.max(...ids);
    state.pageConfig.menberPage.powerList.push({
      id: max + 1,
      name: "",
      imageUrl: require("@/assets/images/btn_power1_n.png"),
    });
    state.pageConfig.menberPage.powerScoreList[selectPowerItem] =
      state.pageConfig.menberPage.powerList;
  },
  // 会员权益等级切换
  switchPowerItem(state, index) {
    selectPowerItem = index;
    state.pageConfig.menberPage.selectPowerItem = index;
    state.pageConfig.menberPage.powerList =
      state.pageConfig.menberPage.powerScoreList[index];
  },
  // 删除会员权益
  deletePower(state, id) {
    const index = state.pageConfig.menberPage.powerList.findIndex(
      (item) => item.id == id
    );
    state.pageConfig.menberPage.powerList.splice(index, 1);
    state.pageConfig.menberPage.powerScoreList[selectPowerItem] =
      state.pageConfig.menberPage.powerList;
  },
  // 添加组件
  addComponent(state, idArr) {
    const page = pageArr[state.selectPage];
    const components = state.pageConfig[page].pageComponents;
    // if(components.length <= 0)
    const ids = components.map((item) => item.id);
    const intRecord = components.find((item) => item.intRecord);
    idArr.forEach((id) => {
      const state = ids.includes(id);
      if (state) {
        const obj = components.find((item) => item.id == id);
        components.push(obj);
      } else {
        components.push({
          id,
          hideGaps: false,
          select: false,
        });
      }
    });
    const newArr = [];
    idArr.forEach((id) => {
      const obj = components.find((item) => item.id == id);
      newArr.push(obj);
    });
    if (intRecord) newArr.unshift(intRecord);
    state.pageConfig[page].pageComponents = newArr;
  },
  // 删除组件
  delComponent(state, id) {
    const page = pageArr[state.selectPage];
    if (!id) return;
    const ids = state.pageConfig[page].pageComponents.map((item) => item.id);
    const index = ids.indexOf(id);
    if (index != -1) {
      state.pageConfig[page].pageComponents.splice(index, 1);
    }
  },
  // 置顶组件
  toppingComponent(state, id) {
    const page = pageArr[state.selectPage];
    if (!id) return;
    let list = state.pageConfig[page].pageComponents;
    const ids = list.map((item) => item.id);
    const intRecord = list.find((item) => item.intRecord);
    const index = ids.indexOf(id);
    const key = list.splice(index, 1)[0];
    intRecord ? list.splice(1, 0, key) : list.unshift(key);
  },
  // 中间页面组件上下切换
  upAndDown(state, { id, type }) {
    const page = pageArr[state.selectPage];
    if (!id) return;
    let list = state.pageConfig[page].pageComponents;
    const index = list.map((item) => item.id).indexOf(id);
    if (type == "moveDown") {
      if (index < list.length - 1) {
        list.splice(index, 1, ...list.splice(index + 1, 1, list[index]));
      }
    }
    if (type == "moveUp") {
      if (index != 0) {
        list.splice(index, 1, ...list.splice(index - 1, 1, list[index]));
      }
    }
  },
  // 右侧配置项移动
  movePower(state, { id, type }) {
    if (!id) return;
    const page = pageArr[state.selectPage];
    const componentIdx = state.pageConfig[page].pageComponents.find(
      (item) => item.select
    ).id;

    let list = state.pageConfig[page][configArr[componentIdx]];

    const index = list.map((item) => item.id).indexOf(id);

    if (type == "moveDown") {
      if (index != list.length - 1) {
        list.splice(index, 1, ...list.splice(index + 1, 1, list[index]));
      }
    }
    if (type == "moveUp") {
      if (index != 0) {
        list.splice(index, 1, ...list.splice(index - 1, 1, list[index]));
      }
    }
    // 会员列表
    if (state.selectPage == 1) {
      console.log(list);
      state.pageConfig.menberPage.powerScoreList[selectPowerItem] =
        state.pageConfig.menberPage.powerList;
    }
  },
  // 切换会员首页卡面背景
  switchCradBg(state, { imageUrl, id }) {
    state.pageConfig.menberPage.currentCrad.card = imageUrl;
    state.pageConfig.menberPage.currentCrad.id = id;
  },
  // 切换会员首页背景图
  switchBgImage(state, { imageUrl, id }) {
    state.pageConfig.menberPage.currentImage.src = imageUrl;
    state.pageConfig.menberPage.currentImage.id = id;
  },
  // 页面列表活动icon替换
  replaceIcon(state, { imageUrl, id }) {
    const page = pageArr[state.selectPage];
    const componentIdx = state.pageConfig[page].pageComponents.find(
      (item) => item.select
    ).id;
    let list = state.pageConfig[page][configArr[componentIdx]];
    const index = list.map((item) => item.id).indexOf(id);
    Vue.set(list[index], "imageUrl", imageUrl);
  },
  // 活动记录icon替换
  replaceUploadIcon(state, imageUrl) {
    const page = pageArr[state.selectPage];
    const component = state.pageConfig[page].pageComponents.find(
      (item) => item.select
    );
    if (component) {
      // 有值代表选中的是等级积分
      state.pageConfig[page].uploadIcon = imageUrl;
    } else {
      // 没有代表是选中头部
      state.pageConfig[page].backgroundSrc = imageUrl;
    }
  },
  // 间隙隐藏显示
  hideGapsChange(state, visible) {
    const index = state.selectPage;
    state.pageConfig[pageArr[index]].pageHideGaps = visible;
    state.pageConfig[pageArr[index]].pageComponents.find(
      (item) => item.select
    ).hideGaps = visible;
  },

  // 热门互动活动是否可见
  handleVisibility(state, id) {
    // 当前选中页面
    const page = pageArr[state.selectPage];
    const cpmId = state.pageConfig[page].pageComponents.find(
      (item) => item.select
    ).id;
    const data = state.pageConfig[page][configArr[cpmId]].find(
      (item) => item.id == id
    );
    data.visibility = !data.visibility;
  },

  checkCurLinkItem(state, item) {
    console.log(item);
    state.curLinkItem = item;
  },
  // 选中链接后返回
  editItemLink(state, params) {
    const page = pageArr[state.selectPage];
    console.log(params);
    const componentIdx = state.pageConfig[page].pageComponents.find(
      (item) => item.select
    ).id;
    let list = state.pageConfig[page][configArr[componentIdx]];
    let index = list.findIndex((item) => item.id == state.curLinkItem.id);
    Vue.set(
      list[index],
      "link",
      pageLink[params.activityType] + `?activityId=${params.id}`
    );
    Vue.set(list[index], "name", params.activityName);
    Vue.set(list[index], "id", params.id);
    Vue.set(list[index], "activityType", params.activityType);
  },
  setDetail(state, item) {
    state.pageConfig = item;
  },
  // 自营存储
  venderTypeChange(state, val) {
      state.venderType = val == '0' ? false : true
    },
};
